import { domReady } from "../utils";

const initPreloader = () => {
  $(".preloader").fadeOut(1000);
};

export default domReady(initPreloader);
